import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { Aside } from "../../features/home/presentation/pages/Aside";
import { Column } from "../components/Column";
import { HomeScreen } from "../../features/home/presentation/pages/HomeScreen";
import { Stylists } from "../../features/home/presentation/pages/Stylists";
import { useEffect, useRef } from "react";
import { Footer } from "../../features/home/presentation/pages/Footer";
import { Restaurants } from "../../features/home/presentation/pages/Restaurants";
import { Nightclub } from "../../features/home/presentation/pages/Nightclub";
import { TypicalPlaces } from "../../features/home/presentation/pages/TypicalPlaces";
import { TouristBus } from "../../features/home/presentation/pages/TouristBus";
import { Adventure } from "../../features/home/presentation/pages/Adventure";
import { Cinema } from "../../features/home/presentation/pages/Cinema";
import { Hotel } from "../../features/home/presentation/pages/Hotel";

export const AppRouter = () => {
	return (
		<Routes>
			<Route element={<Layout />}>
				<Route
					path="/"
					element={<HomeScreen />}
				/>
				<Route
					path="estilistas"
					element={<Stylists />}
				/>
				<Route
					path="restaurantes"
					element={<Restaurants />}
				/>
				<Route
					path="discotecas"
					element={<Nightclub />}
				/>
				<Route
					path="lugares_tipicos"
					element={<TypicalPlaces />}
				/>
				<Route
					path="mirabus"
					element={<TouristBus />}
				/>
				<Route
					path="aventura"
					element={<Adventure />}
				/>
				<Route
					path="cine"
					element={<Cinema />}
				/>
				<Route
					path="hoteles"
					element={<Hotel />}
				/>
			</Route>
			<Route
				path="/*"
				element={<Navigate to="/" />}
			/>
		</Routes>
	);
};

const Layout: React.FC = () => {
	const location = useLocation();
	const mainRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (mainRef.current) mainRef.current.scrollTo({ top: 0, behavior: "smooth" });
	}, [location.pathname]);

	return (
		<Column
			ref={mainRef}
			className="bg-[#ffffff] overflow-y-auto relative max-h-screen"
		>
			<Aside />
			<Outlet />
			<Footer />
		</Column>
	);
};
